var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "header-content" }, [
    _c(
      "div",
      {
        staticClass: "flex items-center justify-between header-bg",
        staticStyle: {
          width: "100%",
          padding: "0 80px",
          height: "inherit",
          background: "#FFFFFF",
        },
      },
      [
        _c(
          "div",
          { staticClass: "flex items-center" },
          [
            _c("div", { staticClass: "logo-container" }, [
              _c(
                "p",
                {
                  staticClass: "logo-view flex items-center justify-center",
                  on: { click: _vm.goHome },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/logo_copy.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]),
            _c(
              "el-menu",
              {
                staticClass: "flex el-menu-horizontal",
                staticStyle: { "padding-left": "70px" },
                attrs: {
                  "default-active": _vm.activeRoute,
                  "background-color": "transparent",
                  mode: "horizontal",
                },
              },
              _vm._l(_vm.menuList, function (menu) {
                return _c(
                  "div",
                  { key: menu.name },
                  [
                    !menu.children
                      ? _c(
                          "el-menu-item",
                          {
                            attrs: { index: menu.name },
                            on: {
                              click: function ($event) {
                                return _vm.clickMenuList(menu)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(menu.label))]
                            ),
                          ]
                        )
                      : _c(
                          "el-submenu",
                          {
                            attrs: {
                              index: menu.name,
                              "popper-class": "submenu-popper",
                            },
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c(
                                "span",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_vm._v(_vm._s(menu.label))]
                              ),
                            ]),
                            _vm._l(menu.children, function (subItem) {
                              return _c(
                                "div",
                                { key: subItem.name },
                                [
                                  _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: subItem.name },
                                      on: {
                                        click: function ($event) {
                                          return _vm.clickMenuList(subItem)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "title" },
                                          slot: "title",
                                        },
                                        [_vm._v(_vm._s(subItem.label))]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                  ],
                  1
                )
              }),
              0
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex items-center" },
          [
            _c(
              "div",
              {
                staticClass: "file-manage",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ name: "fileManagementGuoJiao" })
                  },
                },
              },
              [
                _c(
                  "el-badge",
                  { staticClass: "badge-dot", attrs: { "is-dot": _vm.isRead } },
                  [
                    _c("div", { staticClass: "flex items-center" }, [
                      _c("i", { staticClass: "el-icon-folder" }),
                      _c("span", { staticClass: "no-wrap" }, [
                        _vm._v("文件管理"),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
            false
              ? _c("el-avatar", {
                  attrs: { size: "small", src: _vm.circleUrl },
                })
              : _vm._e(),
            false
              ? _c(
                  "el-dropdown",
                  {
                    attrs: { trigger: "hover" },
                    on: { command: _vm.clickMenu },
                  },
                  [
                    _c("span", { staticClass: "user-name no-wrap" }, [
                      _vm._v(_vm._s(_vm.userName || "test Name")),
                    ]),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      _vm._l(_vm.menu, function (item) {
                        return _c(
                          "el-dropdown-item",
                          { key: item.path, attrs: { command: item } },
                          [_vm._v(_vm._s(item.label))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }